"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _index = _interopRequireDefault(require("@/components/Store/RangePick/index.vue"));
var _dialog = _interopRequireDefault(require("@/mixins/dialog"));
var _myform = _interopRequireDefault(require("@/mixins/myform"));
var _timeConflit = _interopRequireDefault(require("../mixins/timeConflit"));
var _doubleWeekPlan = require("@/http/interface/sfe/doubleWeekPlan");
var _index2 = require("../statics/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** components */
/** mixins */
/** services */
/** statics */
var _default2 = exports.default = {
  components: {
    RangePick: _index.default
  },
  mixins: [_dialog.default, _myform.default, _timeConflit.default],
  props: {
    // 下拉options配置
    optConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // sr下拉列表
    srList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var defaultForm = {
      planTaskStartTime: "",
      // 开始时间
      planTaskEndTime: "",
      // 结束时间
      remark: ""
    };
    return {
      PT_STATUS_TASK: _index2.PT_STATUS_TASK,
      actualPlanTaskFlag: _index2.PT_STATUS_TASK,
      // Y:实际任务；N:计划任务
      mode: "edit",
      // 编辑模式 view edit
      isVisitType: "",
      // 是否为门店拜访类型
      /** form group */
      formLabelWidth: "120px",
      pickerOptions: {
        start: "00:00",
        end: "23:30",
        step: "00:30"
      },
      // regionProps: { expandTrigger: 'hover' },
      form: Object.assign({}, defaultForm),
      initForm: Object.assign({}, defaultForm),
      rules: {
        validateIpt: [{
          required: true,
          trigger: ["blur"],
          message: this.$t("errorValid.empty")
        }],
        validateChoose: [{
          required: true,
          trigger: ["change"],
          message: this.$t("errorValid.emptySelect")
        }]
      },
      /** other */
      info: {},
      // 访店详情
      canSubmit: true
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return this.mode === "view" ? this.$t("common.check") : this.$t('doubleWeekPlan.role.matterProcessing');
    },
    startOptions: function startOptions() {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.pickerOptions), {}, {
        maxTime: this.form.planTaskEndTime
      });
    },
    endOptions: function endOptions() {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.pickerOptions), {}, {
        minTime: this.form.planTaskStartTime
      });
    }
  },
  methods: {
    // open dialog init
    init: function init(typeFlag, row) {
      var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'edit';
      this.isVisitType = typeFlag; // 是否为门店拜访类型
      this.isShowModel = true;
      var _ref = row || {},
        _ref$region = _ref.region,
        region = _ref$region === void 0 ? "" : _ref$region,
        _ref$city = _ref.city,
        city = _ref$city === void 0 ? "" : _ref$city,
        _ref$district = _ref.district,
        district = _ref$district === void 0 ? "" : _ref$district;
      var PCD = [region, city, district].filter(function (i) {
        return !!i;
      }).join(" / ");
      this.info = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, row), {}, {
        PCD: PCD // 当前因为api没code，直接用文本展示
      });
      this.mode = mode; // 只有浏览模式，没有编辑模式
      // 初始化编辑数据
      var newForm = {
        planTaskStartTime: row.planTaskStartTime,
        planTaskEndTime: row.planTaskEndTime,
        remark: row.remark
      };
      this.form = Object.assign({}, newForm);
      this.initForm = Object.assign({}, newForm);
    },
    /** save event */saveItem: function saveItem() {
      var _this = this;
      // 预览模式
      if (this.mode === "view") {
        this.isShowModel = false;
        return false;
      }
      // 编辑模式
      this.$refs["dataForm"].clearValidate();
      this.$refs["dataForm"].validate(function (valid) {
        if (!valid) return;
        // 重复触发
        if (!_this.canSubmit) {
          return false;
        }
        _this.canSubmit = false;
        var params = (0, _objectSpread2.default)({
          planTaskInfoPk: _this.info.planTaskInfoPk
        }, _this.form);
        (0, _doubleWeekPlan.finishOtherPlan)(params).then(function () {
          // 任务签到 带上签到成功的时间
          _this.$emit("taskCheckinSuccess", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.info), _this.form));
          _this.$emit("refresh");
          _this.isShowModel = false;
        }).catch(function (err) {
          // 失败
          _this.errorHandle(err, "dataForm");
          // 如果是时间冲突了，则弹出冲突弹窗
          var _this$form = _this.form,
            planTaskStartTime = _this$form.planTaskStartTime,
            planTaskEndTime = _this$form.planTaskEndTime;
          var conflitParams = {
            planTaskDate: _this.info.planTaskDate,
            actualPlanTaskFlag: _this.actualPlanTaskFlag,
            timeList: [{
              startTime: planTaskStartTime,
              endTime: planTaskEndTime
            }]
          };
          _this.timeConflitHandle(err.errorInfos, conflitParams);
        }).finally(function () {
          _this.canSubmit = true;
        });
      });
    }
  }
};